module.exports = __webpack_public_path__ + "img/tiaosheng.531072b8.png";